import { useRequestState } from '../../../utils/hooks';
import { AppState } from '../../../types';
import { useSelector } from 'react-redux';
import { getActiveHeatmaps, getSavedHeatmapsById } from '../selectors';
import { filterOverlays } from '../../overlays/utils';
import { useMemo } from 'react';

type useSavedHeatmapsArgs = {
  includeOverlaidObjects: boolean;
};

export const useSavedHeatmaps = (args?: useSavedHeatmapsArgs) => {
  const requestStateStatus = useRequestState((state: AppState) => state.heatmaps.allHeatmaps);

  const heatmapsById = useSelector(getSavedHeatmapsById);

  const filtered = useMemo(
    () => (args?.includeOverlaidObjects ? heatmapsById : filterOverlays(heatmapsById)),
    [args?.includeOverlaidObjects, heatmapsById],
  );

  return {
    byId: filtered,
    ...requestStateStatus,
    activeHeatmaps: useSelector(getActiveHeatmaps),
  };
};
